var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"Neues Video"}},[_c('video-form',{attrs:{"video":_vm.video,"submit-label":"Neues Video anlegen","form-submitted":_vm.saveVideo,"mode":"new"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }